import type { Presentation } from 'src/generated/graphql-viewer';
import type { Slide } from 'src/viewer/components/slide-preview/slide-preview';

/**
 * Maps an array of presentations to an array of slides.
 * Each slide is enriched with its groupId from the corresponding presentation.
 * @param presentations
 * @param language
 * @returns
 */
export function mapPresentationsToSlides(
  presentations: Pick<Presentation, 'language' | 'groupId' | 'slides'>[] | undefined | null,
  language: string | undefined
): Slide[] {
  if (!presentations || !language) return [];

  const slides: Slide[] = presentations
    .filter((presentation) => presentation.language === language)
    .reduce<Slide[]>((acc, presentation) => {
      if (!Array.isArray(presentation.slides)) return acc;

      const enrichedSlides = presentation.slides
        .filter((slide) => !!slide)
        .map((slide) => ({
          ...slide,
          groupId: presentation.groupId,
        }));

      return acc.concat(enrichedSlides);
    }, []);

  return slides;
}
